import http from '@/api/http'
import { API_BASE_URL } from '@/config/env'
import { adminList, adminRequest } from '@/entities/admin/api/adminRequest'
import { mapAdminExchangeRate } from '@/entities/admin/model/mapAdminExchangeRate'
import { mapAdminSystemWalletsPayload } from '@/entities/admin/model/mapAdminSystemWallets'
import { mapAdminWallet } from '@/entities/admin/model/mapAdminWallet'

export const ADMIN_WALLETS_PAGE_SIZE = 20

export async function fetchAdminWallets({
  limit = ADMIN_WALLETS_PAGE_SIZE,
  skip = 0,
  filter = {},
  sort = {},
} = {}) {
  if (!API_BASE_URL) {
    return { items: [], total: 0 }
  }

  const payload = await adminList('/admin/wallets', { limit, skip, filter, sort })
  const list = Array.isArray(payload.data)
    ? payload.data.map((item) => mapAdminWallet(item)).filter(Boolean)
    : []

  return {
    items: list,
    total: Number(payload.total) || list.length,
  }
}

export async function fetchAdminWalletById(id) {
  if (!id || !API_BASE_URL) {
    return null
  }

  const payload = await adminRequest(() =>
    http.get(`/admin/wallet/${id}`, { params: { details: 1 } }),
  )
  return mapAdminWallet(payload.data)
}

export async function fetchAdminExchangeRates() {
  if (!API_BASE_URL) {
    return []
  }

  const payload = await adminRequest(() => http.get('/admin/wallet/exchange-rates'))
  const ratesRaw = payload.data?.rates
  return Array.isArray(ratesRaw)
    ? ratesRaw.map((item) => mapAdminExchangeRate(item)).filter(Boolean)
    : []
}

export async function fetchAdminSystemWallets() {
  if (!API_BASE_URL) {
    return mapAdminSystemWalletsPayload({ data: {} })
  }

  const payload = await adminRequest(() => http.get('/admin/wallets/system'))
  return mapAdminSystemWalletsPayload(payload)
}

export async function createAdminRestaurantWallet(restaurantId) {
  const id = String(restaurantId ?? '').trim()
  if (!id) {
    throw new Error('restaurant_id required')
  }

  const payload = await adminRequest(() =>
    http.post('/admin/wallet', { type: 'restaurant', restaurant_id: id }),
  )
  return mapAdminWallet(payload.data)
}
